import React, { useState, useEffect, useCallback } from "react";
import * as moment from "moment";
import { ReactComponent as CardMenu } from "assets/img/icons/card-menu.svg";
import { CSSTransition } from "react-transition-group";
import ClickAwayListener from "react-click-away-listener";

export default ({ time, setTime, color }) => {
  const [showFilter, setShowFilter] = useState(null);
  const filterStyle = {
    boxShadow:
      "0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)",
    background: "white",
  };

  const [timeFilter, setTimeFilter] = useState({
    name: "All Time",
    value: null,
  });
  const [availableFilters] = useState([
    {
      name: "All Time",
      value: null,
    },
    {
      name: "Today",
      value: moment().format("YYYY-MM-DD"),
    },
    {
      name: "30 Days",
      value: moment().subtract(30, "days").format("YYYY-MM-DD"),
    },
    {
      name: "60 Days",
      value: moment().subtract(60, "days").format("YYYY-MM-DD"),
    },
    {
      name: "90 Days",
      value: moment().subtract(90, "days").format("YYYY-MM-DD"),
    },
  ]);

  const setFilter = useCallback(() => {
    setTimeFilter(
      availableFilters.find((filter) => {
        return filter.value === time;
      })
    );
  }, [availableFilters, time]);

  useEffect(() => {
    setFilter();
  }, [setFilter]);

  const handleFilters = (event) => {
    setShowFilter(() => (showFilter ? null : event.currentTarget));
  };

  const hideFilters = () => {
    setShowFilter(null);
  };

  const selectFilter = (event, filter) => {
    event.preventDefault();
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();

    setTimeFilter(filter);
    setTime(filter.value);

    hideFilters();
  };

  return (
    <div
      className="timeFilterCard"
      style={{
        border: `1px solid ${color === "white" ? "#ffffff85" : "#00000052"}`,
      }}
      onClick={handleFilters}
    >
      <div aria-haspopup="true" className="timeFilterHeader" title="Filter">
        <span
          style={{ color: color, paddingRight: "3px" }}
          className="timeFilterHeading"
        >
          {timeFilter.name}
        </span>
        <CardMenu
          style={{ width: "1.3rem", fill: color }}
          className="timeFilterImage"
        />
      </div>
      <CSSTransition
        in={Boolean(showFilter)}
        timeout={300}
        unmountOnExit
        classNames="dropdown-element"
      >
        <ClickAwayListener onClickAway={hideFilters}>
          <div style={filterStyle} className="timeFilter">
            <ul className="timeFilterDropDownMenu">
              {availableFilters.map((filter, index) => (
                <li
                  key={index}
                  onClick={(event) => selectFilter(event, filter)}
                >
                  <p key={filter.value} className="dropdown-item p-cursor">
                    {filter.name}
                  </p>
                </li>
              ))}
            </ul>
          </div>
        </ClickAwayListener>
      </CSSTransition>
    </div>
  );
};
